<template>
  <main role="main" class="col content-spacing">
    <div
      class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom"
    >
      <b-row>
        <b-col>
          <h1 class="h2">
            {{ `Investidores do Investimento ${state.investmentName}` }}
          </h1>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <div class="btn-group mr-2">
            <BaseButtonComponent to="/investments" variant="primary-action"
              >Voltar para Investimentos</BaseButtonComponent
            >
          </div>
        </b-col>
      </b-row>
    </div>

    <div
      class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center mb-3"
    >
      <b-form-input
        autofocus
        v-on:keyup.enter="search"
        v-model="viewData.search"
        placeholder="Digite um termo e pressione enter para buscar"
      ></b-form-input>
    </div>

    <b-container v-if="true" style="margin-right: unset">
      <b-row align-content="end">
        <b-col>
          <h5 class="h5" style="text-align: end">
            {{ `A distribuir ${formatCurrency(state.totalInvestment)}` }}
          </h5>
        </b-col>
      </b-row>
    </b-container>

    <loading-list v-if="viewData.loading"></loading-list>
    <div v-else-if="!viewData.loading" class="table-responsive">
      <table class="table b-table  table-hover table-bordered">
        <thead>
          <tr style="background: ghostwhite">
            <td>Acumulado</td>
            <td></td>
            <td></td>
            <td class="text-right"></td>
            <td class="text-right">
              {{ formatNumberCurrency(state.totalRequestedSign) }}
            </td>
            <td class="text-right">
              {{ formatNumberCurrency(state.totalRequestedDeposit) }}
            </td>
            <td></td>

            <td></td>
            <td class="text-right">
              {{ formatNumberCurrency(state.totalInvestimentoActive) }}
            </td>
            <td class="text-right">
              {{ formatNumberCurrency(state.totalInvestimentoPending) }}
            </td>
          </tr>
        </thead>
        <thead>
          <tr style="background: ghostwhite">
            <td>Específico</td>
            <td></td>
            <td>
              {{ formatNumberCurrency(state.totalRequestedrequestedValue) }}
            </td>

            <td class="text-right">
              {{ formatNumberCurrency(state.totalApproved) }}
            </td>
            <td class="text-right">
              {{ formatNumberCurrency(state.totalEspecificSign) }}
            </td>
            <td class="text-right">
              {{ formatNumberCurrency(state.totalEspecificPay) }}
            </td>
            <td v-if="false" class="text-right">
              {{ formatNumberCurrency(state.totalInvestment) }}
            </td>
            <td></td>
            <td>
              {{ formatNumberCurrency(state.totalActiveEspecific) }}
            </td>
            <td></td>
            <td></td>
          </tr>
        </thead>
        <thead>
          <tr>
            <td>Nome</td>
            <td class="text-right">Meses</td>
            <td class="text-right">
              Solicitado <br />
              Especfífico
            </td>
            <td class="text-right">Aprovar</td>
            <td class="text-right">Assinar</td>
            <td class="text-right">Pagar</td>

            <td class="text-right">Status</td>
            <td class="text-right"></td>
            <td class="text-right">Ativo</td>
            <td class="text-right">
              Solicitado <br />
              acumulado
            </td>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in state.list" :key="item.id">
            <td>{{ item.name }}</td>
            <td>
              <b-form-input
                class="text-right"
                v-bind:disabled="true"
                v-model="item.duration"
              ></b-form-input>
            </td>
            <td class="text-right">
              {{ formatCurrency(item.requestedValue) }}
            </td>

            <td>
              <b-form-input
                :formatter="formatCurrencyNoFraction"
                class="text-right"
                v-bind:disabled="
                  item.hasRendaCreated ||
                    (item.status !== 'WAITING_APPROVAL' &&
                      item.status !== 'APPROVED')
                "
                v-model="item.value"
                placeholder="Informe o valor do investimento"
                :state="isOk('value')"
                @change="calc()"
                @keypress="isNumber($event)"
              ></b-form-input>
            </td>
            <td class="text-right">
              {{ formatCurrency(item.toSign) }}
            </td>
            <td class="text-right">
              {{ formatCurrency(item.toPay) }}
            </td>

            <td>
              <b-form-select
                v-model="item.status"
                :options="viewData.status"
                :state="isOk('status')"
                @change="calc()"
                class="mb-3"
              >
                <option disabled value>Selecione um status</option>
              </b-form-select>
            </td>
            <td style="text-align: right">
              <BaseButtonComponent
                @click="update(item)"
                variant="tertiary-action"
              >
                Gravar
              </BaseButtonComponent>
            </td>
            <td class="text-right">
              {{
                formatCurrency(item.totalInvestedOfInvestorByInvestmentActive)
              }}
            </td>
            <td class="text-right">
              {{
                formatCurrency(item.totalInvestedOfInvestorByInvestmentPending)
              }}
            </td>
          </tr>
        </tbody>
      </table>

      <b-pagination-nav
        class="mt-3"
        :link-gen="linkGen"
        :number-of-pages="state.pageCount"
        use-router
      ></b-pagination-nav>
    </div>
    <empty-list v-else-if="!viewData.loading"></empty-list>
  </main>
</template>

<script>
import helpers from '../../vue/helpers';
import { Api } from '../../vue/api';
import { BaseButtonComponent } from '../../ui/buttons';

const API = new Api();

export default {
  name: 'investment-investors-index',
  data: function() {
    return {
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 2,
        masked: false,
      },
      state: {
        list: [],
        page: 1,
        pageCount: 1,
        count: 0,
        investmentName: '',
        totalRequested: 0,
        totalRequestedSign: 0,
        totalRequestedToApprove: 0,
        totalRequestedDeposit: 0,
        totalApproved: 0,
        totalInvestment: 0,
        totalRequestedrequestedValue: 0,
        totalInvestmentOriginal: 0,
        totalInvestimentApprove: 0,
        totalInvestimentoActive: 0,
        totalInvestimentoPending: 0,
        totalEspecificSign: 0,
        totalEspecificPay: 0,
      },
      viewData: {
        loading: true,
        search: '',
      },
    };
  },
  computed: {},

  beforeMount: async function() {
    const _id = this.$route.params ? this.$route.params.id : 0;
    this.viewData.id = _id;

    if (this.$route.query && this.$route.query.search) {
      this.viewData.search = this.$route.query.search;
    }
    this.viewData.status = [
      { value: 'WAITING_APPROVAL', text: 'Aguardando Aprovação' },
      { value: 'APPROVED', text: 'Aprovar' },
      { value: 'CANCELED', text: 'Cancelado' },
      { value: 'WAITING_SIGN', text: 'Assinar' },
      { value: 'WAITING_DEPOSIT', text: 'Pagar' },
      { value: 'ACTIVE', text: 'Ativo' },
      { value: 'INACTIVE', text: 'Inativo' },
      { value: 'AMORTIZED', text: 'Amortizado' },
    ];

    await this.getAll();
  },
  methods: {
    formatCurrency: value => {
      //if (!isNaN(value)) {
      if (value) {
        return parseFloat(
          value
            .toString()
            .replace(/\./g, '')
            .replace(/,/g, '.'),
        ).toLocaleString('pt-BR', {
          currency: 'BRL',
          minimumFractionDigits: 2,
        });
      }
      //}
    },
    formatCurrencyNoFraction: value => {
      //if (!isNaN(value)) {
      if (value) {
        return parseFloat(
          value
            .toString()
            .replace(/\./g, '')
            .replace(/,/g, '.'),
        ).toLocaleString('pt-BR', {
          currency: 'BRL',
          minimumFractionDigits: 0,
        });
      }
      //}
    },
    formatNumberCurrency: value => {
      if (value) {
        return parseFloat(value.toString()).toLocaleString('pt-BR', {
          currency: 'BRL',
          minimumFractionDigits: 2,
        });
      }
    },

    linkGen(pageNum) {
      return pageNum === 1 ? '?' : `?page=${pageNum}`;
    },
    search() {
      this.$router.push({
        query: { page: 1, search: this.viewData.search, id: this.viewData.id },
      });
    },
    async getAll() {
      try {
        this.viewData.loading = true;

        const result = await API.post('/execute', {
          path:
            '/investment-investors' +
            `/${this.viewData.id}/?` +
            helpers.toQueryString(this.$route.query),
          method: 'get',
        });

        this.state.list = { ...result.model.list };
        this.state.investmentName = result.model.investmentName;

        this.state.totalInvestimentoActive = result.model.list.reduce(
          (accum = 0, item) => {
            return accum + item.activeValue;
          },
          0,
        );

        this.state.totalEspecificSign = result.model.list.reduce(
          (accum = 0, item) => {
            return accum + item.toSign;
          },
          0,
        );

        this.state.totalEspecificPay = result.model.list.reduce(
          (accum = 0, item) => {
            return accum + item.toPay;
          },
          0,
        );

        this.state.totalInvestimentApprove = result.model.list.reduce(
          (accum = 0, item) => {
            return accum + item.totalInvestedOfInvestorByInvestmentSignDeposit;
          },
          0,
        );

        this.state.totalInvestimentoPending = result.model.list.reduce(
          (accum = 0, item) => {
            return accum + item.totalInvestedOfInvestorByInvestmentPending;
          },
          0,
        );

        this.state.totalRequestedrequestedValue = result.model.list.reduce(
          (accum = 0, item) => {
            return accum + item.requestedValue;
          },
          0,
        );

        this.state.totalRequestedSign = result.model.list.reduce(
          (accum = 0, item) => {
            return accum + item.totalInvestedOfInvestorByInvestmentSign;
          },
          0,
        );

        this.state.totalRequestedToApprove = result.model.list.reduce(
          (accum = 0, item) => {
            return accum + item.totalInvestedOfInvestorByInvestmentToApprove;
          },
          0,
        );

        this.state.totalRequestedDeposit = result.model.list.reduce(
          (accum = 0, item) => {
            return accum + item.totalInvestedOfInvestorByInvestmentDeposit;
          },
          0,
        );

        this.state.totalInvestimentoActive = result.model.list.reduce(
          (accum = 0, item) => {
            return accum + item.totalInvestedOfInvestorByInvestmentActive;
          },
          0,
        );

        this.viewData.loading = false;
        this.state.totalInvestmentOriginal = result.model.totalInvestment;
        this.calc();
      } catch (ex) {
        this.$toast.error(helpers.getFirstError(ex));
      }
    },
    recalcAvailable() {
      this.state.totalInvestment =
        this.state.totalInvestmentOriginal -
        this.state.totalInvestimentoPending -
        this.state.totalInvestimentoActive -
        this.state.totalInvestimentApprove;
    },
    isNumber($event) {
      return helpers.isNumber($event);
    },
    calc() {
      this.state.totalRequested = 0;
      this.state.totalApproved = 0;

      for (const item of Object.keys(this.state.list)) {
        this.state.totalRequested =
          this.state.totalRequested +
          parseFloat(this.state.list[item].originalValue);
      }

      for (const item of Object.keys(this.state.list)) {
        this.state.totalApproved =
          this.state.totalApproved +
          parseFloat(
            this.state.list[item].value
              ? this.state.list[item].value
                  .toString()
                  .replace(/\./g, '')
                  .replace(/,/g, '.')
              : 0,
          );
      }

      /*         this.state.totalRequested = this.state.list.reduce(
          (accum = 0, item) => {
            return accum + item.value;
          },
          0,
        ); */

      /*       this.state.totalApproved = this.state.list.reduce((accum = 0, item) => {
        return accum + item.value;
      }, 0); */

      this.state.totalInvestment =
        this.state.totalInvestmentOriginal - this.state.totalApproved;

      //totalRequested: 0,
      // totalApproved: 0,
    },
    calcTotals(item) {
      this.state.totalInvestimentoPending = isNaN(
        this.state.totalInvestimentoPending,
      )
        ? 0
        : parseFloat(this.state.totalInvestimentoPending);
      this.state.totalInvestimentoActive = isNaN(
        this.state.totalInvestimentoActive,
      )
        ? 0
        : parseFloat(this.state.totalInvestimentoActive);
      this.state.totalInvestimentoPending = isNaN(
        this.state.totalInvestimentoPending,
      )
        ? 0
        : parseFloat(this.state.totalInvestimentoPending);

      console.log(item);
      if (item.status !== item.originalStatus) {
        switch (item.originalStatus) {
          case 'WAITING_SIGN':
            this.state.totalInvestimentApprove =
              this.state.totalInvestimentApprove - parseFloat(item.value);
            item.originalValue = 0;
            item.originalStatus = item.status;
            break;
          case 'WAITING_DEPOSIT':
            this.state.totalInvestimentApprove =
              this.state.totalInvestimentApprove - parseFloat(item.value);
            item.originalValue = 0;
            item.originalStatus = item.status;
            break;
          case 'ACTIVE':
            this.state.totalInvestimentoActive =
              this.state.totalInvestimentoActive - parseFloat(item.value);
            item.originalValue = 0;
            item.originalStatus = item.status;
            break;
          case 'WAITING_APPROVAL':
            this.state.totalInvestimentoPending = this.state.totalInvestimentoPending =
              this.state.totalInvestimentoPending - parseFloat(item.value);
            item.originalValue = 0;
            item.originalStatus = item.status;
            break;
          default:
            break;
        }
      }

      if (item.status === 'WAITING_SIGN' || item.status === 'WAITING_DEPOSIT') {
        if (
          item.originalStatus === 'WAITING_SIGN' ||
          item.originalStatus === 'WAITING_DEPOSIT'
        ) {
          this.state.totalInvestimentApprove =
            this.state.totalInvestimentApprove +
            parseFloat(item.value) -
            item.originalValue;
          item.originalValue = parseFloat(item.value);
        } else {
          this.state.totalInvestimentApprove =
            this.state.totalInvestimentApprove + parseFloat(item.value);
        }
      }

      if (item.status === 'ACTIVE') {
        if (item.originalStatus === 'ACTIVE') {
          this.state.totalInvestimentoActive =
            this.state.totalInvestimentoActive +
            parseFloat(item.value) -
            item.originalValue;
          item.originalValue = parseFloat(item.value);
        } else {
          this.state.totalInvestimentoActive =
            this.state.totalInvestimentoActive + parseFloat(item.value);
        }
      }

      if (item.status === 'WAITING_APPROVAL') {
        if (item.originalStatus === 'WAITING_APPROVAL') {
          this.state.totalInvestimentoPending = this.state.totalInvestimentoPending =
            this.state.totalInvestimentoPending +
            parseFloat(item.value) -
            item.originalValue;
          item.originalValue = parseFloat(item.value);
        } else {
          this.state.totalInvestimentoPending =
            this.state.totalInvestimentoPending + parseFloat(item.value);
        }
      }

      this.state.totalInvestimentoPending = isNaN(
        this.state.totalInvestimentoPending,
      )
        ? 0
        : parseFloat(this.state.totalInvestimentoPending);
      this.state.totalInvestimentoActive = isNaN(
        this.state.totalInvestimentoActive,
      )
        ? 0
        : parseFloat(this.state.totalInvestimentoActive);
      this.state.totalInvestimentoPending = isNaN(
        this.state.totalInvestimentoPending,
      )
        ? 0
        : parseFloat(this.state.totalInvestimentoPending);

      this.recalcAvailable();
    },
    getError(property) {
      return helpers.getError(this.viewData.errors, property);
    },
    isOk(property) {
      let hasError = helpers.hasError(this.viewData.errors, property);
      if (hasError) {
        return false;
      }
    },
    async showInstallments(item) {},
    async update(item) {
      try {
        this.viewData.loading = true;

        const sValue =
          item.status === 'CANCELED'
            ? '0'
            : item.value
                .toString()
                .replace(/\./g, '')
                .replace(/,/g, '.');

        const oData = {
          value: sValue,
          status: item.status,
        };
        const result = await API.post('/execute', {
          path: `/investment-investors/${item.idInvest}/${item.idInvestor}`,
          method: 'put',
          data: oData,
        });

        this.$bvToast.toast('Investimento do Investidor alterado com sucesso', {
          title: `Sucesso`,
          variant: 'success',
          solid: true,
        });
        //this.$toast.success('Investimento do Investidor alterado com sucesso');
        await this.getAll();
      } catch (ex) {
        this.$bvToast.toast(helpers.getFirstError(ex), {
          title: `Erro`,
          variant: 'error',
          solid: true,
        });
        await this.getAll();
        //this.$toast.error(helpers.getFirstError(ex));
      }
    },
    async remove(item) {
      const ok = await this.$bvModal.msgBoxConfirm(
        `Deseja mesmo excluir [${item.name}] ?`,
        {
          title: 'Confirmar Exclusão',
          size: 'md',
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: 'Sim',
          cancelTitle: 'Não',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true,
        },
      );

      if (!ok) {
        return;
      }

      try {
        this.viewData.loading = true;

        const result = await API.post('/execute', {
          path: '/investment/' + item.id,
          method: 'delete',
        });

        this.$toast.success('Investimento excluída com sucesso');
        await this.getAll();
      } catch (ex) {
        this.$toast.error(helpers.getFirstError(ex));
      }
    },
  },
  components: {
    BaseButtonComponent,
  },
};
</script>
